"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const pulse_components_1 = require("@pcs/pulse-components");
const react_pdf_1 = require("react-pdf");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const sliceReview_1 = require("../../../slice/sliceReview");
const store_1 = require("../../../store");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
react_pdf_1.pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${react_pdf_1.pdfjs.version}/build/pdf.worker.min.js`;
const UploadNewAsset = () => {
    const { assets, folder, project, round, historyPhases } = (0, react_redux_1.useSelector)(selectors_1.default);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const projectId = (round === null || round === void 0 ? void 0 : round.job_id) || (project === null || project === void 0 ? void 0 : project.value);
    const handleOnFileDrop = (newFiles) => {
        dispatch((0, sliceReview_1.updateAssets)([...assets, ...newFiles]));
    };
    const handleRemoveNewFile = (removedFile, position) => {
        const newAssets = [
            ...assets.filter((asset, index) => {
                return index !== position;
            }),
        ];
        dispatch((0, sliceReview_1.updateAssets)(newAssets));
    };
    const handleChange = (value) => {
        dispatch((0, sliceReview_1.updateFolder)(value === null || value === void 0 ? void 0 : value.dirId));
    };
    const handleRenameFiles = (newAssets) => {
        dispatch((0, sliceReview_1.updateAssets)(newAssets));
    };
    (0, react_1.useEffect)(() => {
        if (assets.length > 0) {
            dispatch((0, sliceReview_1.enableNextBtn)());
            return;
        }
        dispatch((0, sliceReview_1.disableNextBtn)());
    }, [assets, historyPhases]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(pulse_components_1.PulseUploaderDropzone, { classes: {
                root: styles_modules_less_1.default.uploaderRoot,
                dropzone: styles_modules_less_1.default.uploaderDropzone,
                fileEditor: styles_modules_less_1.default.uploaderText,
            }, isMultiple: true, files: assets, onFileDrop: handleOnFileDrop, onFileRename: handleRenameFiles, onFileRemove: (file, positionFile = 0) => {
                handleRemoveNewFile(file, positionFile);
            }, visible: true, PulseFolderSelectProps: {
                classes: {
                    selectOptionRoot: styles_modules_less_1.default['dropzone__select-option--root'],
                    selectOptionLabel: styles_modules_less_1.default['dropzone__select-option--label'],
                },
                jobId: projectId,
                labelName: 'Select folder',
                valueChangeHandler: handleChange,
                value: folder,
                selectFirst: true,
                isMulti: false,
                isClearable: false,
                placeholder: 'Type to search for a folder or create new',
            }, allowDuplicateFiles: true })));
};
exports.default = UploadNewAsset;
